// What saving a drawn polygon sends to the users API: the WKT string, and whether the save
// updates the saved area or creates a new one. Pure: no React, router, Firebase or services
// imports.
import type { CountryCode } from '../config/countries';

/** An outer ring of [longitude, latitude] points as WKT, closed or not exactly as drawn. */
export function ringToWkt(ring: number[][]): string {
  return `POLYGON((${ring.map(([x, y]) => `${x} ${y}`).join(',')}))`;
}

export interface CustomPolygonBody {
  name: string;
  description: string;
  type: 'custom_polygon';
  geometry: string;
  country_code: CountryCode;
}

export type CustomPolygonWrite =
  | { kind: 'update'; id: string; body: CustomPolygonBody }
  | { kind: 'create'; body: CustomPolygonBody };

/**
 * A saved area holds one polygon. When editing one, only the first drawn polygon (index 0)
 * updates it; any further polygon is a new area, so nothing is overwritten.
 */
export function buildCustomPolygonWrite(a: {
  ring: number[][];
  name: string;
  description: string;
  country: CountryCode;
  index: number;
  editAreaId?: string;
}): CustomPolygonWrite {
  const body: CustomPolygonBody = {
    name: a.name,
    description: a.description,
    type: 'custom_polygon',
    geometry: ringToWkt(a.ring),
    country_code: a.country,
  };
  if (a.editAreaId && a.index === 0) return { kind: 'update', id: a.editAreaId, body };
  return { kind: 'create', body };
}
